import axiosInstance from "../axiosInterceptor";

export async function updateLiveSessionQuestion(questionId, body) {
  const response = await axiosInstance.put(
    `student/liveSessionHelp/updateQuestion/${questionId}`,
    body
  );
  const data = response?.data;
  return data;
}
